import dayjs from "dayjs";
import { TextField } from "components/field";
import React from "react";

const FromTimestampToDateField = (props) => {
  const { source, record } = props;
  const newRecord = {};
  if(record && record[source]){
    let format = 'YYYY-MM-DD';
    if (props.format) {
      format = props.format;
    }
    newRecord[source] = dayjs(record[source]).format(format);
  } else {
    newRecord[source] = '';
  }

  return (
    <TextField {...props} record={newRecord}/>
  );
};

export  default FromTimestampToDateField;



// WEBPACK FOOTER //
// ./src/util/fields/FromTimestampToDateField.js